import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select'
import { IoClose } from 'react-icons/io5';
import { useState } from 'react';

export default function StatusDialog(props) {

    const [UpDatedStatus,setUpdatedData] = useState(null)


    const handleChange=(event)=>{
        setUpdatedData(event.target.value)
    }


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h3'>Status</Typography>
                </DialogTitle>
                <Box sx={{position:'absolute',top:'0px',right:'0px',padding:'10px',cursor:'pointer',fontSize:'22px'}} onClick={props.handleClose}>
                    <IoClose/>
                </Box>
                <DialogContent sx={{paddingBlock:0}}>
                    <DialogContentText id="alert-dialog-description">
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={UpDatedStatus?UpDatedStatus:props.data?.status}
                                onChange={handleChange}
                            >
                                <MenuItem value={'active'}>Active</MenuItem>
                                <MenuItem value={'inactive'}>Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', mt:1}}>
                    <Button variant='contained' color='secondary' sx={{ borderRadius: '8px' }} onClick={props.handleClose} >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
